import React, { useMemo } from 'react';
import { useParams, useSelector } from 'umi';
import type { ListMenuItemType } from '@op/types/menu';
import AuthPathReport from './AuthPathReport';

function findMenu(list: ListMenuItemType[], nameEn: string): ListMenuItemType | null {
  for (const item of list) {
    if (item.name_en === nameEn) return item;
    const found = findMenu(item.opinion_list || [], nameEn);
    if (found) return found;
  }
  return null;
}
const AuthPath = () => {
  const { reportId } = useParams() as { reportId: string };
  const listMenu = useSelector((state: any) => state.opinionCommon?.listMenu || []);
  const currentMenu = useMemo(() => findMenu(listMenu, reportId), [listMenu, reportId]);

  return (
    <AuthPathReport
      reportId={reportId}
      currentMenu={currentMenu}
      resId="opinion"
      reportTypeId="opinion_pc_v2"
      getAuthPath={(menu) => (menu as any).report_url || ''}
      getMenuId={(menu) => String((menu as any).id || '')}
      getPageType={() => 'auth_path'}
    />
  );
};

export default AuthPath;